import script from "./AdminFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFooter.vue?vue&type=script&setup=true&lang=js"

import "./AdminFooter.vue?vue&type=style&index=0&id=3569dc72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3569dc72"]])

export default __exports__